module.exports = __webpack_public_path__ + "img/Group124.5abbb9f2.png";